import React from "react";

//tools
import { handleAiChatAction } from "../../tools/aiChatActions";

// styles
import styles from "./TextMessage.module.css";

function sanitizeHtml(html) {
	const allowedTags = ['b', 'i', 'u', 'em', 'strong', 'br', 'a', 'span', 'div', 'p', 'ul', 'ol', 'li', 'img'];
	const div = document.createElement('div');
	div.innerHTML = html;
	const walk = (node) => {
		if (node.nodeType === 1) {
			const tag = node.tagName.toLowerCase();
			if (!allowedTags.includes(tag)) {
				node.parentNode.removeChild(node);
				return;
			}
			[...node.attributes].forEach(attr => {
				if (/^on/i.test(attr.name) || ['src', 'href'].includes(attr.name) && /^(javascript:|data:)/i.test(attr.value)) {
					node.removeAttribute(attr.name);
				}
			});
		}
		for (let child of [...node.childNodes]) walk(child);
	};
	walk(div);
	return div.innerHTML;
}

function parseNode(node, idx = 0) {
	const regex = /##(\d+)##(.*?)##/g;
	if (node.nodeType === 3) {
		const text = node.nodeValue;
		let parts = [];
		let lastIndex = 0;
		let match;
		let partIdx = 0;
		while ((match = regex.exec(text))) {
			if (match.index > lastIndex) {
				parts.push(text.slice(lastIndex, match.index));
			}
			const [full, productId, productName] = match;
			parts.push(
				<a
					className={styles['product-modal-button']}
					href={productId}
					key={`product-${productId}-${match.index}`}
					onClick={e => {
						e.preventDefault();
						e.stopPropagation();
						__cng_common.product_modal.open(productId)
					}}
				>
					{productName}
				</a>
			);
			lastIndex = match.index + full.length;
			partIdx++;
		}
		if (lastIndex < text.length) {
			parts.push(text.slice(lastIndex));
		}
		return parts.length === 1 ? parts[0] : parts;
	}
	if (node.nodeType === 1) {
		const tag = node.tagName.toLowerCase();
		const dataAction = node.getAttribute('data-action');
		const children = [];
		for (let i = 0; i < node.childNodes.length; i++) {
			const child = parseNode(node.childNodes[i], i);
			if (Array.isArray(child)) {
				children.push(...child);
			} else {
				children.push(child);
			}
		}
		
		const props = { key: `${tag}-${idx}` };
		
		if (node.attributes) {
			for (let attr of node.attributes) {
				const propName = attr.name === 'class' ? 'className' : attr.name;
				props[propName] = attr.value;
			}
		}
		
		if (dataAction) {
			const existingClass = props.className || '';
			props.className = existingClass ? `${existingClass} ${styles['product-modal-button']}` : styles['product-modal-button'];
			
			props.onClick = (e) => {
				e.preventDefault();
				e.stopPropagation();
				handleAiChatAction(dataAction, { closeAllModals: true });
			};
		}
		
		return React.createElement(tag, props, ...children);
	}
	return null;
}

const TextMessage = ({ message }) => {
	const content = React.useMemo(() => {
		let text = typeof message?.text === "string" ? message.text : "";
		let safeHtml = sanitizeHtml(text.replace(/<br\s*\/?>/gi, "<br>"));
		const parser = new window.DOMParser();
		const doc = parser.parseFromString(`<div>${safeHtml}</div>`, "text/html");
		const root = doc.body.firstChild;
		const result = [];
		for (let i = 0; i < root.childNodes.length; i++) {
			const node = parseNode(root.childNodes[i], i);
			if (Array.isArray(node)) {
				result.push(...node);
			} else {
				result.push(node);
			}
		}

		return result;
	}, [message?.text, message?.intent]);
	return (
		<div className={styles["message-text"]}>
			{content}
		</div>
	);
};

export default TextMessage;
